import { render } from "./Gamecenter.vue?vue&type=template&id=3e10dc1e"
import script from "./Gamecenter.vue?vue&type=script&lang=ts"
export * from "./Gamecenter.vue?vue&type=script&lang=ts"

import "./Gamecenter.vue?vue&type=style&index=0&id=3e10dc1e&lang=css"
script.render = render

export default script